<template>
    <c-dialog ref="dialog" title="会员库" width="900" @resolve="resolve">
        <m-search ref="search" @search="search">
            <c-form ref="form" inline>
                <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                <!-- <c-form-item type="input" label="用户名" name="login_name"></c-form-item> -->
                <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
                <c-form-item type="select" label="代理等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
            </c-form>
        </m-search>

        <c-table ref="table" height="600">
            <c-table-column
                    type="selector"
                    :multiple="!!multiple"
            ></c-table-column>

            <c-table-column label="状态" name="state" width="40">
                <template v-slot="{data}">
                    <span v-if="data.state == 1" style="color:green">启用</span>
                    <span v-if="data.state == 2" style="color:red">禁用</span>
                </template>
            </c-table-column>

            <c-table-column
                    label="会员手机号"
                    name="user_manage_mobilephone"
                    width="120"
            >
                <template v-slot="{data}">
                    <span v-if="data.user_manage_mobilephone && data.user_manage_mobilephone!=''">{{ data.user_manage_mobilephone }}</span>
                    <span v-else>--</span>
                </template>
            </c-table-column>

            <c-table-column
                    label="会员头像/昵称"
                    name="head_photo"
                    width="300"
            >
                <template v-slot="{data}">
                    <div class="flex-center-cross">
                        <c-image :src="data.head_photo" preview size="25" style="margin-right: 10px;"></c-image>
                        <span>{{ data.nick_name }}</span>
                    </div>
                </template>
            </c-table-column>

            <!-- <c-table-column
                    label="用户名"
                    name="login_name"
                    width="60"
            >
                <template v-slot="{data}">
                    <span v-if="data.login_name && data.login_name!=''">{{ data.login_name }}</span>
                    <span v-else>--</span>
                </template>
            </c-table-column> -->

            <c-table-column
                    label="等级"
                    name="user_level_name"
					width="80"
            >
                <template v-slot="{data}">
                    <span v-if="data.user_level_name" style="color:blue">{{ data.user_level_name }}</span>
                    <span v-else>普通用户</span>
                </template>
            </c-table-column>

            <c-table-column
                    label="注册时间"
                    name="create_date"
					width="140"
            >
            </c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
export default {
    props: {
        multiple: Boolean
    },
    methods: {
        search(data) {
            this.$refs.table.load({
                url: '/platform_user/list',
                data
            });
        },

        open() {
            this.$refs.form.clear();
            this.$refs.search.search();
            this.$refs.dialog.open();
        },

        resolve(stop) {
            var data = this.$refs.table.getRow('selected');
            if (!data.length) {
                stop();
                this.$message({
                    text: '请选择会员'
                });
                return;
            }
            this.$emit('resolve', Array.from(data, item => Object.assign({}, item.data)));
        }
    }
}
</script>